import React, { useEffect, useState } from "react";

const COLORS = ["#F2765A", "#B4E04A", "#FBB03B", "#4C8FD6", "#8FD9F2", "#FFE07A", "#6FBE4A"];

// Lightweight CSS confetti burst (no extra deps). Renders `count` pieces once.
export function Confetti({ count = 90, duration = 3500 }) {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShow(false), duration);
    return () => clearTimeout(t);
  }, [duration]);
  if (!show) return null;
  const pieces = Array.from({ length: count });
  return (
    <div className="pointer-events-none fixed inset-0 z-[60] overflow-hidden" aria-hidden="true">
      {pieces.map((_, i) => {
        const left = Math.random() * 100;
        const delay = Math.random() * 0.6;
        const dur = 2.4 + Math.random() * 1.6;
        const size = 7 + Math.random() * 8;
        const color = COLORS[i % COLORS.length];
        const rotate = Math.random() * 360;
        const round = Math.random() > 0.5;
        return (
          <span
            key={i}
            style={{
              left: `${left}%`,
              width: size,
              height: size * (round ? 1 : 1.6),
              background: color,
              borderRadius: round ? "50%" : "2px",
              animation: `confetti-fall ${dur}s ${delay}s ease-in forwards`,
              transform: `rotate(${rotate}deg)`,
            }}
            className="absolute -top-4"
          />
        );
      })}
      <style>{`
        @keyframes confetti-fall {
          0% { transform: translateY(-20px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(105vh) rotate(720deg); opacity: 0.9; }
        }
      `}</style>
    </div>
  );
}
